import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, concatMap, filter, Observable } from 'rxjs';
import { UserProfile } from '@shared/interfaces/users.interface';
import { ConferenceCreateInfo, ConferenceMember } from '@shared/interfaces/conference.interface';
import { Notification } from '@shared/interfaces/notification.interface';
import { MultiFactorData } from '../../modules/auth/interfaces/multi-factor.intercace';
import { LoginType } from '@shared/enums/login-type.enum';

@Injectable({
  providedIn: 'root'
})
export class Storage {
  sessionId$: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  authToken$: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  MxIp$: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  lastCreatedConferenceHost$: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  login$: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  notificationsList$: BehaviorSubject<Notification> = new BehaviorSubject<Notification>(null);
  conferenceId$: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  trustedDeviceId$: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  trustedDeviceCode$: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  userId$: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  userName$: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  apiVersion$: BehaviorSubject<number> = new BehaviorSubject<number>(null);

  isLoading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  isRequestInProgress$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  deleteWhenOwnerLeave$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  isDialogOpened$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  isAppointmentSendInProgress$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  isLogoutHappened$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  customProperties$: BehaviorSubject<Office.CustomProperties> = new BehaviorSubject<Office.CustomProperties>(null);
  contactsList$: BehaviorSubject<ConferenceMember[]> = new BehaviorSubject<ConferenceMember[]>([]);
  multiFactorData$: BehaviorSubject<MultiFactorData> = new BehaviorSubject<MultiFactorData>(null);
  conferenceInfo$: BehaviorSubject<ConferenceCreateInfo> = new BehaviorSubject<ConferenceCreateInfo>(null);
  loginType$: BehaviorSubject<LoginType> = new BehaviorSubject<LoginType>(null);

  appointmentSaveEvent$: BehaviorSubject<any> = new BehaviorSubject(null);
  dialogRef$: BehaviorSubject<any> = new BehaviorSubject(null);

  private saveQueue$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(private ngZone: NgZone) {}

  setCustomProperty(key: string, value: string): void {
    this.customProperties$.getValue().set(key, value);
  }

  removeCustomProperty(key: string): void {
    this.customProperties$.getValue().remove(key);
  }

  saveCustomProperties(): void {
    this.saveQueue$.next(true);
  }

  getSaveQueue(): Observable<void> {
    return this.saveQueue$.pipe(
      filter(Boolean),
      concatMap(() => {
        return new Observable<void>((observer) => {
           this.customProperties$.getValue().saveAsync(() => {
             this.ngZone.run(() => {
               observer.next();
               observer.complete();
             });
           });
        });
      })
    );
  }
}
